import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import { TFunction } from "i18next";
import { ApiStateType } from "customHooks/useApi";
import useGetMetadata from "customHooks/useGetMetadata";
import useValuesFromSource from "customHooks/useValuesFromSource";
import { useTranslation } from "react-i18next";
import useCompleoReactHookForm from "customHooks/useCompleoReactHookForm";
import FormModal from "customHooks/useCompleoReactHookForm/components/FormModal";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import { ListDefinitionType } from "Pages/Users/components/useCustomLists";
import { ILocalAssessment } from "./helpers";

interface IAssessmentModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (assessment: Partial<ILocalAssessment>) => void;
    editData?: ILocalAssessment;
    pipelineStages: Array<{ id: string; name: string }>;
    tLocal: TFunction;
}

const AssessmentModal = (props: IAssessmentModalProps) => {
    const { open, onClose, onSave, editData, pipelineStages } = props;

    const lists: ListDefinitionType[] = [
        {
            fieldName: "resultsToStageRule.targetStage",
            data: pipelineStages.map((stage) => ({
                value: stage.id,
                label: stage.name
            })),
            labelName: "label",
            valueName: "value"
        }
    ];

    const module = "JOBVIEWASSESSMENTSMODAL";
    const [metadata] = useGetMetadata(module);

    const [t, i18n, readyTranslation] = useTranslation(module, {
        useSuspense: false
    });

    const [initialValues] = useValuesFromSource(metadata, true, {
        ...editData,
        jobId: "ignore"
    });

    const ready = readyTranslation && metadata.status === "success";

    const handleSubmit = async (values: Partial<ILocalAssessment>) => {
        const retorno: Compleo.IObject = {};
        retorno.status = 200;
        try {
            // Instead of API calls, just pass the data to the parent
            onSave(values);
            onClose();
        } catch (ex) {
            return ex.response;
        }
        return retorno;
    };

    const postReturn: ApiStateType = {
        status: "success",
        response: {},
        exception: null
    };

    const [formCompleo, finished] = useCompleoReactHookForm({
        t: t,
        ready: ready,
        i18nV: i18n,
        postMethod: handleSubmit,
        postReturn: postReturn,
        FormType: FormModal,
        metadadosRetorno: metadata,
        valuesFromSource: initialValues,
        formGroupPaperElevation: 0,
        secondaryButtonFunction: onClose,
        customLists: lists
    });

    let FormReturn: JSX.Element = <Loading />;
    if (finished && ready) {
        FormReturn = formCompleo;
    }

    return (
        <Dialog
            fullWidth
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="md"
            open={open}
            onClose={onClose}
            aria-labelledby="assessment-modal-title"
        >
            <DialogTitle id="assessment-modal-title">
                {t("modalTitle")}
            </DialogTitle>
            <DialogContent>{FormReturn}</DialogContent>
        </Dialog>
    );
};

export default AssessmentModal;
